import React from 'react';
import { Box, Typography, CircularProgress, Tooltip } from '@mui/material';

export default function PollIndicator({
  loading,
  lastPoll,
  hasNewEvents,
  newEventCount,
  isPulsing,
  onNewEventsClick,
  transport // 'websocket' or 'polling'
}) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {loading && <CircularProgress size={20} />}

      {hasNewEvents && newEventCount > 0 ? (
        <Tooltip title="Click to go to top" arrow>
          <Box
            onClick={onNewEventsClick}
            sx={{
              width: 20,
              height: 20,
              borderRadius: '50%',
              backgroundColor: '#b71c1c',
              boxShadow: '0 0 8px #b71c1c',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'scale(1.1)',
                boxShadow: '0 0 12px #b71c1c'
              }
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: 'white',
                fontWeight: 700,
                fontSize: '0.7rem',
                lineHeight: 1
              }}
            >
              {newEventCount}
            </Typography>
          </Box>
        </Tooltip>
      ) : (
        !hasNewEvents && (
          <Tooltip
            title={`${transport === 'websocket' ? 'WebSocket connected' : 'Polling active'}${lastPoll ? ` • Last update: ${lastPoll.toLocaleTimeString()}` : ''} • Click to scroll to top`}
            arrow
          >
            <Box
              onClick={onNewEventsClick}
              sx={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                backgroundColor: '#2e7d32',
                boxShadow: isPulsing ? '0 0 12px #2e7d32' : 'none',
                transition: 'all 0.3s ease',
                transform: isPulsing ? 'scale(1.1)' : 'scale(1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                '@keyframes pulse': {
                  '0%': { transform: 'scale(1)', boxShadow: 'none' },
                  '50%': { transform: 'scale(1.1)', boxShadow: '0 0 12px #2e7d32' },
                  '100%': { transform: 'scale(1)', boxShadow: 'none' }
                },
                animation: isPulsing ? 'pulse 1s ease-out' : 'none',
                '&:hover': {
                  transform: 'scale(1.1)',
                  boxShadow: '0 0 12px #2e7d32'
                }
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  color: 'white',
                  fontWeight: 700,
                  fontSize: '0.65rem',
                  lineHeight: 1
                }}
              >
                {transport === 'websocket' ? 'W' : 'P'}
              </Typography>
            </Box>
          </Tooltip>
        )
      )}
    </Box>
  );
}
